import script from "./ProductAttributes.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductAttributes.vue?vue&type=script&setup=true&lang=ts"

import "./ProductAttributes.vue?vue&type=style&index=0&id=4962adf0&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4962adf0"]])

export default __exports__